// extracted by mini-css-extract-plugin
export default {"countries":"countries_countries__wsqMC"};